// extracted by mini-css-extract-plugin
export default {"container":"style_container__kEEyb","content":"style_content__q2k7t","descWrapper":"style_descWrapper__1WPnr"};